import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { SPACE_SIZES } from '../../../constants/spaces.js';
import modules_490d7587 from '../styles/Space.module.less.js';

/**
 * @description Set components spacing
 *
 * @component
 * @example
 * ```jsx
 * <Space size="m">
 *   <span>content</span>
 *   <span>content</span>
 *   <span>content</span>
 * </Space>
 * ```
 */
const Space = React.forwardRef((props, ref) => {
    const { direction, size, align, justify, wrap, inline, className, children, style, ...restProps } = props;
    const cx = useStyles(modules_490d7587);
    const classNames = cx(className, 'container', {
        [`direction-${direction}`]: direction,
        [`align-${align}`]: align,
        [`justify-${justify}`]: justify,
        wrap,
        inline,
    });
    const elementStyles = { ...style };
    const sizes = React.useMemo(() => {
        if (!size)
            return;
        const results = [0, 0];
        const normalizedSize = Array.isArray(size) ? size : [size, size];
        normalizedSize.forEach((g, index) => {
            results[index] = g || 0;
        });
        return results;
    }, [size]);
    if (sizes) {
        // eslint-disable-next-line prefer-destructuring
        elementStyles.columnGap = sizes[0];
        // eslint-disable-next-line prefer-destructuring
        elementStyles.rowGap = sizes[1];
    }
    return (React.createElement("div", { ref: ref, "data-qa": "Space", className: classNames, style: elementStyles, ...restProps }, children));
});
Space.defaultProps = {
    direction: 'row',
    size: SPACE_SIZES.S0,
    wrap: false,
};

export { Space };
//# sourceMappingURL=Space.js.map
